import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  
  state: {
    locale: JSON.parse(localStorage.getItem('locale')),
    currentUser: JSON.parse(localStorage.getItem('currentUser')),
    resultList: [],
  },
  
  getters: {
    getCurrentUser: state => state.currentUser,
    getLocale: state => state.locale,
    getResultList: state => state.resultList,
  },
  
  mutations: {
    loggedIn(state, user) {
      state.currentUser = user;
    },
    loggedOut(state) {
      state.currentUser = null;
    },
    updateLocale(state, newLocale) {
      state.locale = newLocale
    },
    updateResultList(state, resultList) {
      state.resultList = resultList
    }
  },

  actions: {
    loggedIn({commit}, user) {
      commit('loggedIn', user);
    },
    loggedOut({commit}) {
      commit('loggedOut');
    },
    updateLocale({ commit }, newLocale) {
      commit('updateLocale', newLocale)
    },
    updateResultList({ commit }, resultList) {
      commit('updateResultList', resultList)
    },
  }
})
